function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWormholeNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.18 86.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.29 43.05A47.76 47.76 0 0 0 16.72 9.63a1.7 1.7 0 0 0-1.2-.5H4.34a1.67 1.67 0 0 0-1.67 1.67v11.49A1.69 1.69 0 0 0 4.24 24a19.15 19.15 0 0 1 0 38.18 1.68 1.68 0 0 0-1.57 1.62v11.49A1.68 1.68 0 0 0 4.34 77h11.18a1.66 1.66 0 0 0 1.2-.51 47.75 47.75 0 0 0 13.57-33.44Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51 63.8a1.68 1.68 0 0 0-1.57-1.66 19.15 19.15 0 0 1 0-38.18 1.69 1.69 0 0 0 1.57-1.67V10.8a1.67 1.67 0 0 0-1.67-1.67H57.66a1.7 1.7 0 0 0-1.2.5 47.93 47.93 0 0 0 0 66.83 1.66 1.66 0 0 0 1.2.51h11.18a1.68 1.68 0 0 0 1.67-1.68Z",
    style: {
      fill: "#0073ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.06 3.14a1.89 1.89 0 0 0-1.75 2.58 102.89 102.89 0 0 1 7.05 37.33 102.87 102.87 0 0 1-7 37.32 1.89 1.89 0 0 0 1.7 2.63h17a1.88 1.88 0 0 0 1.74-2.58 102.33 102.33 0 0 1 0-74.65 1.88 1.88 0 0 0-1.74-2.58Z",
    style: {
      fill: "#00f3d7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWormholeNetwork);
export default __webpack_public_path__ + "static/media/wormhole-network.c546f205d9f8931abfaf7243d7ba72f0.svg";
export { ForwardRef as ReactComponent };